const e=async(e,t,n)=>{let{data:r}=await e.get(`/orgs/${t}/apps`,{params:n});return r};export{e as getOrgApps};
//# sourceMappingURL=get-org-apps.mjs.map